/* eslint-disable-next-line no-useless-escape */
const exclusionRouteRegexes = [/\/contacts\/\d+\/objectLists\/create/];
export const isGlobalToolbarExcludedRoute = currentPath => {
  if (!currentPath) return false;
  for (const exclusionRouteRegex of exclusionRouteRegexes) {
    if (exclusionRouteRegex.test(currentPath)) {
      return true;
    }
  }
  return false;
};